import React from 'react';
import DefaultModal from '../defaultModal/DefaultModal';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';

function ErrorMessageModal() {
  const { showErrorModal, setShowErrorModal } = useModal();

  return (
    <DefaultModal
      show={showErrorModal}
      setShow={setShowErrorModal}
      className="ticket-refund-modal"
    >
      <h3 className="text-2xl font-big-bold text-primary text-center">
        {showErrorModal}
      </h3>
    </DefaultModal>
  );
}

export default ErrorMessageModal;
